import { render, staticRenderFns } from "./view-img.vue?vue&type=template&id=1a0ede26&scoped=true&"
import script from "./view-img.vue?vue&type=script&lang=js&"
export * from "./view-img.vue?vue&type=script&lang=js&"
import style0 from "./view-img.vue?vue&type=style&index=0&id=1a0ede26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ede26",
  null
  
)

export default component.exports